<template>
  <section>
    <div class="searchBox">
      <el-input
        style="width: 200px; margin-right: 10px"
        v-model="filterParam.Name"
        placeholder="请输入用户名称"
      ></el-input>
      <el-select
        placeholder="请选择核销类型"
        clearable
        v-model="filterParam.Type"
        style="margin-right: 10px"
      >
        <el-option
          v-for="(label, value) in cardType"
          :key="value"
          :value="value"
          :label="label"
        ></el-option>
      </el-select>
      <el-select
        placeholder="请选择所在场馆"
        clearable
        v-model="filterParam.VenueId"
        style="margin-right: 10px"
        @change="getCourtDataPage"
      >
        <el-option
          v-for="(item, idx) in stadiumData"
          :value="item.Id"
          :label="item.Name"
          :key="'stadiumData_item_' + idx"
        ></el-option>
      </el-select>
      <el-select
        placeholder="请选择订场"
        clearable
        v-model="filterParam.VenueCourtId"
        style="margin-right: 10px"
      >
        <el-option
          v-for="(item, idx) in courtData"
          :value="item.Id"
          :label="item.Name"
          :key="'courtData_item_' + idx"
        ></el-option>
      </el-select>
      <el-button type="primary" @click="handleSearch">搜索</el-button>
      <el-button type="primary" @click="handleReset">重置</el-button>
      <el-button type="primary" @click="exportExcel">导出</el-button>
    </div>
    <el-table
      v-if="list"
      :data="list"
      v-loading="listLoading"
      style="width: 100%"
      ref="table"
      class="custom-tbl"
    >
      <el-table-column type="index" label="序号" width="80"></el-table-column>
      <el-table-column prop="CreateBy" label="核销员"></el-table-column>
      <el-table-column prop="Type" label="核销类型">
        <template slot-scope="scope">
          <span>{{ cardType[scope.row.Type] || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Venue" label="场馆">
        <template slot-scope="scope">
          <span>{{ scope.row.Venue ? scope.row.Venue.Name : "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="VenueCourt" label="订场">
        <template slot-scope="scope">
          <span>{{
            scope.row.VenueCourt ? scope.row.VenueCourt.Name : "--"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Price" label="核销金额"></el-table-column>
      <el-table-column prop="CreateTime" label="核销时间"></el-table-column>
      <el-table-column prop="Code" label="卡号"></el-table-column>
      <el-table-column prop="WxUserInfoName" label="持卡人"></el-table-column>
      <el-table-column prop="TelPhone" label="手机号"></el-table-column>
      <el-table-column prop="Remark" label="备注"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button plain size="mini" @click="handleDetail(scope.row)"
            >查看</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="mt16">
      <el-col :span="24" class="toolbar">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page="page.currentPage"
          :page-sizes="[10, 20, 30, 40, 50, 100]"
          :page-size="page.pageSize"
          :total="total"
          style="float: right"
        >
        </el-pagination>
      </el-col>
    </div>
    <el-dialog
      title="台账详情"
      :visible.sync="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form label-width="120px" ref="addForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="核销员：">
              <span>{{ detail.CreateBy }}</span>
            </el-form-item>
            <el-form-item label="场馆：">
              <span v-if="detail.Venue">{{ detail.Venue.Name || "--" }}</span>
              <span v-else>--</span>
            </el-form-item>
            <el-form-item label="核销金额：">
              <span>{{ detail.Price }}</span>
            </el-form-item>
            <el-form-item label="备注：">
              <span>{{ detail.Remark }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="核销类型：">
              <span>{{ detail.Type }}</span>
            </el-form-item>
            <el-form-item label="订场：">
              <span v-if="detail.VenueCourt">{{
                detail.VenueCourt.Name || "--"
              }}</span>
              <span v-else>--</span>
            </el-form-item>
            <el-form-item label="核销时间：">
              <span>{{ detail.CreateTime }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </section>
</template>
<script>
import {
  standingBookList,
  checkStandingBookDetail,
  exportStandingBook,
  getStadiumData,
  getCourtData,
  getSiteData,
} from "@/api/standingBook/standingBook";
import Toolbar from "../../components/Toolbar";
import { downloadXls, dateNow } from "@/utils/util.js";
export default {
  components: { Toolbar },
  data() {
    return {
      page: {
        currentPage: 1,
        pageSize: 10,
      },
      list: [],
      listLoading: false,
      total: 0,
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      filterParam: {
        Type: "1",
        Name: "",
        VenueId: "",
        VenueCourtId: "",
      },
      detail: {},
      cardType: {
        1: "工会卡",
        2: "会员卡",
        3: "订场卡",
        4: "购票卡",
        5: "报名卡",
      },
      stadiumData: [], // 场馆数据
      courtData: [], // 订场数据
    };
  },
  created() {
    this.getStadiumDataPage();
    this.getCourtDataPage();
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 导出
    exportExcel() {
      exportStandingBook(this.filterParam)
        .then((res) => {
          if (res && res.data) {
            downloadXls(res.data, `台账记录表${dateNow()}.xlsx`);
          } else {
            console.error("导出失败，未获取到数据");
          }
        })
        .catch((error) => {
          console.error("导出失败", error);
        });
    },
    // 获取场馆列表
    async getStadiumDataPage() {
      const res = await getStadiumData();
      this.stadiumData = res.data.response;
    },
    // 获取订场列表
    async getCourtDataPage() {
      if (!this.filterParam.VenueId) return;
      this.filterParam.VenueCourtId = "";
      const res = await getCourtData({ Id: this.filterParam.VenueId });
      this.courtData = res.data.response;
    },
    handleSearch() {
      this.initPage();
      this.getList();
    },
    handleReset() {
      this.filterParam = {
        Type: "1",
      };
      this.courtData = [];
      this.initPage();
      this.getList();
    },
    handleDetail(row) {
      checkStandingBookDetail({
        Id: row.Id,
      }).then((res) => {
        this.detail = res.data.response;
        this.addFormVisible = true;
      });
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getList();
    },
    initPage() {
      this.page.currentPage = 1;
      this.page.pageSize = 10;
    },
    getList() {
      this.listLoading = true;
      let para = {
        page: this.page.currentPage,
        intPageSize: this.page.pageSize,
        ...this.filterParam,
      };

      standingBookList(para).then((res) => {
        console.log(res);
        this.total = res.data.response.dataCount;
        this.list = res.data.response.data;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}

.searchBox {
  display: flex;
  align-items: center;
  margin: 20px;
}
</style>
